import { render } from "./modelUploadExcelButton.vue?vue&type=template&id=c60c36ca&scoped=true"
import script from "./modelUploadExcelButton.vue?vue&type=script&lang=js"
export * from "./modelUploadExcelButton.vue?vue&type=script&lang=js"

import "./modelUploadExcelButton.vue?vue&type=style&index=0&id=c60c36ca&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60c36ca"]])

export default __exports__